import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	padding: 16px;
	border-radius: 16px;
	background-color: ${helpers.color.contextCardBackground};
	height: 100%;
	display: flex;
	flex-direction: column;
`
